import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    code: 'REGLES',
    icon: 'bi bi-list-check',
    id: 1711,
    label: 'tmw.regles.menu-title',
    subItems: [
      {
        code: 'REGLE',
        icon: 'bi bi-diagram-3',
        link: '/backoffice/regle',
        id: -222,
        label: 'tmw.regle.menu-title',
        parentId: 7109,
      },
      {
        code: 'REGLE_GROUPE',
        access: 'REGLE_GROUPE_VIEW',
        icon: 'bi bi-diagram-3',
        link: '/backoffice/groupe-regle',
        id: 1223,
        label: 'tmw.groupeRegle.menu-groupe-title',
        parentId: 7109,
      },
    ],
  },
  {
    code: 'ADMIN',
    icon: 'bi bi-gear-fill',
    id: 17109,
    label: 'tmw.administration.menu-title',
    subItems: [
      {
        code: 'ANNEXE',
        icon: 'bi bi-bell-fill',
        link: '/backoffice/annexe-context',
        id: -616,
        label: 'tmw.annex-config.menu-title',
        parentId: 17109,
      },
      {
        code: 'PLANIFICATION',
        link: '/backoffice/tache',
        id: 17160,
        label: 'tmw.planification.menu-title',
        parentId: 17109,
      },
      {
        code: 'NOTIFICATIONS',
        icon: 'bi bi-bell-fill',
        link: '/backoffice/notification-context',
        id: 17151,
        label: 'Notifications',
        parentId: 17109,
      },
      {
        code: 'EDITION',
        link: '/backoffice/edition',
        id: 17152,
        label: 'tmw.edition.menu-title',
        parentId: 17109,
      },
      {
        code: 'WORKFLOW',
        link: '/backoffice/workflow',
        id: 17154,
        label: 'tmw.workflow.menu-title',
        parentId: 17109,
      },
    ],
  },
  {
    code: 'USERS',
    icon: 'bi bi-person-fill-gear',
    id: 17112,
    label: 'Gestion Utilisateurs',
    subItems: [
      {
        code: 'UTILISATEUR',
        link: '/backoffice/utilisateur',
        id: 17157,
        label: 'tmw.utilisateur.menu-title',
        parentId: 17112,
      },
      {
        code: 'ROLE',
        link: '/backoffice/role',
        id: 17158,
        label: 'tmw.role.menu-title',
        parentId: 17112,
      },
      {
        code: 'AFFECTATION_MODULES',
        link: '/backoffice/habilitation',
        id: 17159,
        label: 'tmw.affectationModules.menu-title',
        parentId: 17112,
      },
    ],
  },
  {
    code: 'REFERENTIELS',
    icon: 'bi bi-database-fill-gear',
    id: 17111,
    label: 'tmw.referentiels.menu-title',
    subItems: [
      {
        code: 'REFERENTIEL',
        link: '/backoffice/referentiel',
        id: 17155,
        label: 'tmw.referentiel.menu-title',
        parentId: 17111,
      },
      {
        code: 'REQUETE',
        link: '/backoffice/requete',
        id: 17156,
        label: 'tmw.requete.menu-title',
        parentId: 17111,
      },
    ],
  },
  {
    code: 'PARAMETRAGES',
    icon: 'bi bi-database-fill-gear',
    id: 18111,
    label: 'tmw.parametrages.menu-title',
    subItems: [
      {
        id: 18112,
        label: 'tmw.matriceDelegation.menu-title',
        link: '/backoffice/matrice-delegation',
        parentId: 18111,
      },
    ],
  },
];

export const TEMPLATE_PAGES: MenuItem = {
  id: -999999,
  code: 'TEMPLATE_PAGES',
  label: 'Template Pages',
  isLayout: true,
};